export const textStyles = {
  'title-with-border-bottom': {
    textAlign: 'center',
    fontSize: 'md',
    fontWeight: '600',
    color: 'blue.800',
    borderBottom: 'sm',
    borderColor: 'blue.800',
    width: 'fit-content'
  }
};
